<div class="nsw-card nsw-card--highlight" style="cursor: pointer;">
    <div class="nsw-card__image">
        <img [src]="siteImage" [alt]="siteName" >
    </div>
    <div class="nsw-card__content">        
        <div class="nsw-card__title">            
            <a class="nsw-link nsw-link--icon" href="javascript:void()" (click)="onCardClicked($event)">{{siteName}}</a>
        </div>        
        <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
    </div>

    <div class="favourite-icon-group" #favouriteIcon>
        <div class="rectangle"></div>
        <div class="overlay">
            <app-favourite-icon 
                [siteName]="siteName"
                [showLabel]="false" 
                unselectedIcon="favourites-unselected-light.svg" [tabindex]="0"                                         
                [siteIdentifier]="identifier">
            </app-favourite-icon>
        </div>
    </div>
</div>
